/* ------------------------------------------------------------------------ */
/*		File: cmpProspectus.tsx                                               */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { ICard } from "./cmpProspectus.d";
import Button from "../GenericComponents/Button";
import { getImage } from "../GenericComponents/functions";

import "./cmpProspectus.css"


/* ------------------------------------------------------------------------ */

const Card_Prospectus: React.FC<ICard> = ({card}: ICard) => {
    return (
        <div className="card_prospectus">
            <div className="card_prospectus_img_container">
                <img className="card_prospectus_img" src={getImage(card?.src)} alt="" />

            </div>
            <div className="card_prospectus_details">
                <div className="card_prospectus_first_row">
                    <div className="card_prospectus_mini_square"></div>
                    <p className="card_prospectus_first_row_details">{card?.label}</p>

                </div>
                <p className="card_prospectus_second_row">{card?.description}</p>

            </div>
            <div className="button">
                <Button 
                    classProp={"yellow-button"}
                    label={card!.buttons![0].label}
                    hasIcon={card!.buttons![0].src !== null}
                    src={card!.buttons![0].src !== null ? card!.buttons![0].src : undefined}
                    size={"medium"}
                    textColor={card!.buttons![0].color}
                    onClick={() => {return true} }
                />
            </div>
        </div>
    );
};

export default Card_Prospectus;




